import request from '../../shared/request'

export function getProposalMilestoneTemplate(templateId) {
  return request(`/proposal/milestone/template/${templateId}`)
}

export function getProposalMilestone(proposalId) {
  return request(`/proposal/milestone/${proposalId}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/proposals.js